import { AtemApplication } from "../modules/user/domain/constants";
import { applicationListRules } from "./applicationRules";

const applicationList = {
  suprimentos: AtemApplication.SUPPLY_CHAIN,
  comercial: AtemApplication.SALES_PORTAL,
  portal: AtemApplication.CUSTOMER_PORTAL,
  checklist: AtemApplication.CHECKLIST,
  carregamento: AtemApplication.LOADING,
  vendas: AtemApplication.SALES,
};

// Núcleo PURO da seleção de aplicação. Mantém a lógica legada de rules/url exatamente
// como era; o único acréscimo é brandDomainHost: domínio dedicado de marca (após isIDP)
// força o fluxo Default, ignorando rules/url. Ver openspec change (D3).
export function selectApplication(
  params: { url?: string; rules?: string },
  isIDP: boolean,
  brandDomainHost: boolean
): AtemApplication | applicationListRules {
  if (isIDP) {
    return AtemApplication.IDP;
  }

  // Travamento por domínio dedicado: autoridade sobre o fluxo; ignora rules/url.
  if (brandDomainHost) {
    return AtemApplication.CUSTOMER_PORTAL;
  }

  const subdomain = (params.url ?? "").replace(/^https?:\/\//, "").split(".")[0];

  for (const key in applicationListRules) {
    const rulesValue = applicationListRules[key as keyof typeof applicationListRules];
    if (params?.rules?.includes(rulesValue)) return rulesValue;
  }

  for (const item of Object.keys(applicationList)) {
    if (subdomain.includes(item)) {
      return applicationList[item as keyof typeof applicationList] as AtemApplication;
    }
  }

  return AtemApplication.CUSTOMER_PORTAL;
}
